import { useEffect, useState } from "react";
import axios from "axios";
import "./Products.css";

import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";

/* ===== CATEGORY DATA ===== */
const CATEGORY_OPTIONS = {
  "10/25G": ["10G Switch", "25G Switch"],
  "100G": ["100G Switch"],
  "400G": ["400G Switch"],
  "Modular": ["Modular Chassis", "Line Cards"],
  "NVIDIA": ["Spectrum", "BlueField"],
  "Accessories": ["Cables", "Transceivers", "Power Modules"]
};

export default function AddProduct() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [form, setForm] = useState({
    title: "",
    category: "",
    subCategory: "",
    price: "",
    stock: "",
    warranty: "",
    description: "",
    image: ""
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    const res = await axios.get("http://localhost:5000/api/products");
    setProducts(res.data || []);
  };

  const saveProduct = async () => {
    if (!form.title || !form.category || !form.subCategory || !form.price) {
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);

    const payload = {
      ...form,
      price: Number(form.price),
      stock: Number(form.stock || 0)
    };

    if (editingId) {
      await axios.put(
        `http://localhost:5000/api/products/${editingId}`,
        payload
      );
    } else {
      await axios.post("http://localhost:5000/api/products", payload);
    }

    setForm({
      title: "",
      category: "",
      subCategory: "",
      price: "",
      stock: "",
      warranty: "",
      description: "",
      image: ""
    });

    setEditingId(null);
    setLoading(false);
    fetchProducts();
  };

  const editProduct = (p) => {
    setForm(p);
    setEditingId(p._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const deleteProduct = async (id) => {
    if (!window.confirm("Delete this product?")) return;
    await axios.delete(`http://localhost:5000/api/products/${id}`);
    fetchProducts();
  };

  return (
    <div className="admin-body products-page">
      <Sidebar open={sidebarOpen} />
      <Topbar onMenu={() => setSidebarOpen(!sidebarOpen)} />

      <main className="admin-main">
        <h1 style={{ color: "#374151" }}>{editingId ? "Update Product" : "Add Product"}</h1>

        {/* ===== FORM ===== */}
        <section className="table-card">
          <div className="form-grid">
            <div className="left">
              <label>Title *</label>
              <input
                value={form.title}
                onChange={(e) =>
                  setForm({ ...form, title: e.target.value })
                }
              />

              <label>Category *</label>
              <select
                value={form.category}
                onChange={(e) =>
                  setForm({
                    ...form,
                    category: e.target.value,
                    subCategory: ""
                  })
                }
              >
                <option value="">Select Category</option>
                {Object.keys(CATEGORY_OPTIONS).map((cat) => (
                  <option key={cat} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>

              <label>Sub Category *</label>
              <select
                value={form.subCategory}
                disabled={!form.category}
                onChange={(e) =>
                  setForm({ ...form, subCategory: e.target.value })
                }
              >
                <option value="">Select Sub Category</option>
                {(CATEGORY_OPTIONS[form.category] || []).map((sub) => (
                  <option key={sub} value={sub}>
                    {sub}
                  </option>
                ))}
              </select>

              <label>Description</label>
              <textarea
                value={form.description}
                onChange={(e) =>
                  setForm({ ...form, description: e.target.value })
                }
              />
            </div>

            <div className="right">
              <label>Price *</label>
              <input
                type="number"
                value={form.price}
                onChange={(e) =>
                  setForm({ ...form, price: e.target.value })
                }
              />

              <label>Stock</label>
              <input
                type="number"
                value={form.stock}
                onChange={(e) =>
                  setForm({ ...form, stock: e.target.value })
                }
              />

              <label>Warranty</label>
              <input
                value={form.warranty}
                onChange={(e) =>
                  setForm({ ...form, warranty: e.target.value })
                }
              />

              <label>Image URL</label>
              <input
                value={form.image}
                onChange={(e) =>
                  setForm({ ...form, image: e.target.value })
                }
                placeholder="http://example.com/image.jpg"
              />

              {form.image && <img src={form.image} alt="preview" />}
            </div>
          </div>

          <button
            className="primary"
            onClick={saveProduct}
            disabled={loading}
          >
            {loading
              ? "Saving..."
              : editingId
              ? "Update Product"
              : "Save Product"}
          </button>
        </section>

        {/* ===== TABLE ===== */}
        <section className="table-card">
          <h2 style={{ color: "#374151" }}>All Products</h2>

          <table className="data-table">
            <tbody>
              {products.map((p) => (
                <tr key={p._id}>
                  <td>{p.title}</td>
                  <td>{p.category}</td>
                  <td>{p.subCategory}</td>
                  <td>₹{p.price}</td>
                  <td>
                    <button className="edit" onClick={() => editProduct(p)}>✏️</button>
                    <button className="danger" onClick={() => deleteProduct(p._id)}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </main>

      <Footer />
    </div>
  );
}
